import { render } from "./SkinCare.vue?vue&type=template&id=2265f5f7"
import script from "./SkinCare.vue?vue&type=script&lang=js"
export * from "./SkinCare.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__